export default __webpack_public_path__ + "static/media/desk01.594c0ff8.jpg";